import React from "react";

import styles from "./Summary.module.scss";

const Summary = ({ children, ...rest }) => (
  <div className={`${styles.base} ${rest.className ? rest.className : ""}`}>
    {children}
  </div>
);

export default Summary;
